export default __webpack_public_path__ + "static/media/cancer_3x2_En.7a3f50b7.webp";